import { Component, ElementRef, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SettingsService } from '../../../services/settings/settings.service';
import { MessengerService } from '../../../services/messenger/messenger.service';
import { ChatService } from '../../../services/chat/chat.service';
import { ToasterService } from '../../../services/toaster/toaster.service';

@Component({
  selector: 'app-name-color-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './name-color-modal.html',
  styleUrl: './name-color-modal.scss',
})
export class NameColorModal {
  private settingsService = inject(SettingsService);
  private messengerService = inject(MessengerService);
  private chatService = inject(ChatService);
  private toaster = inject(ToasterService);
  private el = inject(ElementRef);

  public currentUser = this.messengerService.currentUser;
  public currentColor = this.settingsService.userNameColor;
  public selectedColor = signal<string>(this.settingsService.userNameColor());

  public presetColors = [
    { name: 'Rival Purple', hex: '#9F50FF' },
    { name: 'Pure White', hex: '#FFFFFF' },
    { name: 'Neon Cyan', hex: '#00FFCC' },
    { name: 'Gold Champion', hex: '#FFCC00' },
    { name: 'Crimson Red', hex: '#FF3366' },
    { name: 'Electric Blue', hex: '#3399FF' },
    { name: 'Vibrant Green', hex: '#33FF33' },
    { name: 'Sunset Orange', hex: '#FF9900' },
  ];

  /*
   * Select a preset color for preview.
   */
  public selectPreset(hex: string): void {
    this.selectedColor.set(hex);
  }

  /*
   * Save selected name color to server and local settings.
   */
  public saveColor(): void {
    const color = this.selectedColor().trim();
    const hexRegex = /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
    if (!hexRegex.test(color)) {
      this.toaster.warning('Please enter a valid hex color (e.g., #9F50FF).');
      return;
    }

    this.settingsService.saveUserNameColorOnServer(color).subscribe({
      next: () => {
        this.settingsService.userNameColor.set(color);
        this.messengerService.updateUser();
        this.chatService.updateUser();
        this.toaster.success('Username color updated!');

        const closeBtn = this.el.nativeElement.querySelector('[data-bs-dismiss="modal"]');
        if (closeBtn) closeBtn.click();
      },
      error: (err) => {
        console.error('Failed to update username color:', err);
        // Fallback update local state if server endpoint is offline
        this.settingsService.userNameColor.set(color);
        this.toaster.info('Updated local username color.');
        const closeBtn = this.el.nativeElement.querySelector('[data-bs-dismiss="modal"]');
        if (closeBtn) closeBtn.click();
      }
    });
  }
}
